export const getSocialTrackingMetaData = ({ backendTrackingMetaData = { page: '', position: '', trackingTokens: [''] }, propSocialInteractionId = '', referrerUrl, }) => {
    var _a, _b, _c;
    return ({
        trackingMetadata: {
            channel: 'web',
            deliveryTimestamp: new Date(Date.now()).toISOString(),
            referrerUrl: referrerUrl || ((_b = (_a = global === null || global === void 0 ? void 0 : global.top) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.href) || '',
            trackingUUID: propSocialInteractionId,
            userAgent: ((_c = global === null || global === void 0 ? void 0 : global.navigator) === null || _c === void 0 ? void 0 : _c.userAgent) || '',
            ...backendTrackingMetaData,
        },
    });
};
//# sourceMappingURL=get-social-tracking-metadata.js.map